import { render } from "./IknowaCoursePreviewModal.vue?vue&type=template&id=2189c8a0&ts=true"
import script from "./IknowaCoursePreviewModal.vue?vue&type=script&lang=ts"
export * from "./IknowaCoursePreviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__